import prepareTableColumnOptions from '@/utils/prepareTableColumnOptions';

export const COMPLIANCE_DOCUMENT_TABLE_NAME = 'complianceDocuments';

/** Backend enum values for `ComplianceDocument#document_type` */
export const COMPLIANCE_DOCUMENT_TYPE_INSURANCE_CERTIFICATE = 'insurance_certificate';
export const COMPLIANCE_DOCUMENT_TYPE_LICENSE = 'license';

// The columns available to be shown in a complianceDocuments table.
export const COMPLIANCE_DOCUMENT_TABLE_COLUMNS = {
  number: { label: 'Number', key: 'number', sortable: true },
  document_type: { label: 'Document type', key: 'document_type' },
  category: { label: 'Category', key: 'category' },
  insurance_contact: { label: 'Insurer / Issuer Contact', key: 'insurance_contact' },
  phone: { label: 'Contact Phone', key: 'phone' },
  state: { label: 'State', key: 'state' },
  status: { label: 'Status', key: 'status' },
  user_id: { label: 'User', key: 'user_id', sortable: true },
  end_date: { label: 'Expiries', key: 'end_date', sortable: true },
  end_date_from: { label: 'Coverage Expiring From', key: 'end_date_from', filterOnly: true },
  end_date_to: { label: 'Coverage Expiring To', key: 'end_date_to', filterOnly: true },
  manager_id: { label: 'Manager', key: 'manager_id' },
  verified: { label: 'Verified', key: 'verified' },
  deleted_at: { label: 'Active', key: 'active' },
};

// The available work order statuses.
export const COMPLIANCE_DOCUMENT_STATUS_UP_TO_DATE = 'up_to_date';
export const COMPLIANCE_DOCUMENT_STATUS_EXPIRES_SOON = 'expires_soon';
export const COMPLIANCE_DOCUMENT_STATUS_EXPIRED = 'expired';
export const COMPLIANCE_DOCUMENT_STATUS_INACTIVE = 'inactive';

const VARIANT_WARNING = 'warning';
const VARIANT_DANGER = 'danger';
const VARIANT_SUCCESS = 'success';

export const COMPLIANCE_DOCUMENT_STATUS_VARIANTS = {
  [COMPLIANCE_DOCUMENT_STATUS_UP_TO_DATE]: VARIANT_SUCCESS,
  [COMPLIANCE_DOCUMENT_STATUS_EXPIRES_SOON]: VARIANT_WARNING,
  [COMPLIANCE_DOCUMENT_STATUS_EXPIRED]: VARIANT_DANGER,
  [COMPLIANCE_DOCUMENT_STATUS_INACTIVE]: VARIANT_DANGER,
};

// The columns available to be selected in a form that is compatible
// with vue-select and bootstrap-vue selects.
export const COMPLIANCE_DOCUMENT_TABLE_COLUMN_OPTIONS = prepareTableColumnOptions(COMPLIANCE_DOCUMENT_TABLE_COLUMNS);

// The default columns to be shown when the complianceDocuments table loads.
export const COMPLIANCE_DOCUMENT_TABLE_DEFAULT_COLUMNS = [
  COMPLIANCE_DOCUMENT_TABLE_COLUMNS.number,
  COMPLIANCE_DOCUMENT_TABLE_COLUMNS.status,
  COMPLIANCE_DOCUMENT_TABLE_COLUMNS.user_id,
  COMPLIANCE_DOCUMENT_TABLE_COLUMNS.state,
  COMPLIANCE_DOCUMENT_TABLE_COLUMNS.insurance_contact,
  COMPLIANCE_DOCUMENT_TABLE_COLUMNS.end_date,
];

export const COMPLIANCE_DOCUMENT_TABLE_VERIFIED_FILTER_OPTIONS = [
  { text: 'Coverage Verified', value: 'true' },
  { text: 'Not Verified', value: 'false' },
  { text: 'Both', value: null },
];
